<div class="row align-items-center">
  <div class="col-auto">

    @if (paymentMethod.brand === 'visa') {
      <div>
        <i class="fab fa-cc-visa fa-2x"></i>
      </div>
    }

    @if (paymentMethod.brand === 'mastercard') {
      <div>
        <i class="fab fa-cc-mastercard fa-2x"></i>
      </div>
    }

    @if (paymentMethod.brand === 'amex') {
      <div>
        <i class="fab fa-cc-amex fa-2x"></i>
      </div>
    }
  </div>
  <div class="col ms-n2">

    <!-- Heading -->
    <h4 class="mb-1">
      {{ paymentMethod.brand | titlecase }} ...{{ paymentMethod.last4 }}
    </h4>

    <!-- Text -->
    <small class="text-muted">
      Expire le {{ paymentMethod.expirationYear }}-{{ paymentMethod.expirationMonth }}
    </small>

  </div>